import script from "./BulkDeleteModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./BulkDeleteModal.vue?vue&type=script&setup=true&lang=ts"

import "./BulkDeleteModal.vue?vue&type=style&index=0&id=4c54d8ba&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c54d8ba"]])

export default __exports__